module.exports = __webpack_public_path__ + "static/media/trend-icon-stale.2c72ea06.svg";